import { updateDataLayer, getDataLayer } from './datalayer';

const trackVirtualPageView = (additionalData = {}) => {
  if (typeof window === 'undefined' || typeof window._satellite === 'undefined') {
    console.warn('%c[ANALYTICS] Adobe Launch not available', 'color: orange; font-weight: bold');
    return;
  }

  if (additionalData && Object.keys(additionalData).length > 0) {
    updateDataLayer(additionalData);
  }

  const payload = { ...window.tc_vars };

  try {
    window._satellite.track('virtual_page_load', payload);
    console.log(
      `%c[ANALYTICS] virtual_page_load @ ${new Date().toISOString()}`,
      'color: #00bcd4; font-weight: bold; font-size: 11px',
      {
        event: 'virtual_page_load',
        page_type: payload.page_type,
        pagename: payload.pagename,
        full_tc_vars: payload
      }
    );
  } catch (error) {
    console.error('%c[ANALYTICS] Error tracking virtual page view', 'color: red; font-weight: bold', error);
  }
};

// NOTE: Scroll/swipe-based virtual page views have been intentionally removed.
// They caused continuous virtual_page_load events while the user scrolled the
// product grid, resulting in false page views with page_type="scroll".
// Page views are now only sent on explicit navigation events (trackPageView calls).

export const initVirtualPageTracking = () => {
  if (typeof window === 'undefined') return;
  console.log('%c[ANALYTICS] Virtual page tracking initialized (explicit nav only)', 'color: green; font-weight: bold');
};

export const trackPageView = (pageData = {}) => {
  trackVirtualPageView(pageData);
};

export const trackModalView = (modalName) => {
  trackVirtualPageView({
    page_type: 'modal',
    pagename: `${window.location.pathname}#modal-${modalName}`
  });
};

export const cleanupVirtualPageTracking = () => {
  // No listeners to remove — scroll tracking disabled
};








